"use client";
import React from "react";
import s from "../../styles/components/Footer.module.scss";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
   <footer className={s.footer} role="contentinfo">
  <div className={s.inner}>
    <div className={s.brand}>
      <span className={s.dot} aria-hidden="true" />
      <span className={s.copy}>© {year} Muntaza Kehase</span>
      <span className={s.sep} aria-hidden="true">•</span>
      <span className={s.meta}>All rights reserved.</span>
    </div>

    <nav className={s.social} aria-label="Social links">
       <a className={s.icon} href="https://www.linkedin.com/in/munti/"  target="_blank" rel="noreferrer" aria-label="LinkedIn">
        <LinkedInIcon />
      </a>
      <a className={s.icon} href="https://github.com/YOUR_HANDLE" target="_blank" rel="noreferrer" aria-label="GitHub">
        <GitHubIcon />
      </a>
      <a className={s.icon} href="mailto:hello@example.com" aria-label="Email">
        <MailIcon />
      </a>
    </nav>
  </div>
</footer>

  );
}

/** Minimal, clean icons (inline SVG) */
function GitHubIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
      <path
        d="M12 2a10 10 0 0 0-3.16 19.49c.5.09.68-.22.68-.48v-1.7c-2.77.6-3.35-1.17-3.35-1.17-.45-1.14-1.1-1.45-1.1-1.45-.9-.62.07-.61.07-.61 1 .07 1.53 1.03 1.53 1.03.88 1.52 2.31 1.08 2.87.83.09-.65.35-1.08.63-1.33-2.21-.25-4.54-1.1-4.54-4.9 0-1.08.39-1.97 1.03-2.66-.1-.26-.45-1.27.1-2.65 0 0 .84-.27 2.75 1.02A9.6 9.6 0 0 1 12 6.8c.85 0 1.7.12 2.5.35 1.9-1.29 2.74-1.02 2.74-1.02.55 1.38.2 2.39.1 2.65.64.69 1.03 1.58 1.03 2.66 0 3.81-2.33 4.65-4.55 4.9.36.31.68.92.68 1.86v2.81c0 .26.18.58.69.48A10 10 0 0 0 12 2Z"
        fill="currentColor"
      />
    </svg>
  );
}

function LinkedInIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
      <path
        d="M6.5 6.6a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6ZM5 21h3V9H5v12Zm6-12h2.9v1.6h.04c.4-.75 1.4-1.55 2.9-1.55 3.1 0 3.6 2 3.6 4.7V21h-3v-5.6c0-1.3 0-3-1.8-3s-2.1 1.4-2.1 2.9V21h-3V9Z"
        fill="currentColor"
      />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
      <path
        d="M4.5 7.5h15v9h-15v-9Zm0-1.5A1.5 1.5 0 0 0 3 7.5v9A1.5 1.5 0 0 0 4.5 18h15A1.5 1.5 0 0 0 21 16.5v-9A1.5 1.5 0 0 0 19.5 6h-15Z"
        fill="currentColor"
      />
      <path
        d="M4.9 7.9 12 12.6l7.1-4.7"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
